/** Flow catalog page: the launchable-flow grid, its cards, and empty/loading chrome. */

export const flows = {
  title: 'Flows',
  subtitle: 'Pick a flow to launch. Some flows may pause to ask you a question mid-run.',
  loading: 'Loading flows…',
  emptyState: 'No flows are available for your account yet. Check back soon.',
  unavailable: 'Unavailable',
  interactiveBadge: 'Interactive · may ask you questions',
  start: 'Start',
  history: 'History'
}
